import React, { useState } from 'react';

export default function ClassroomRegistrationForm(props) {
  const section = props.section
  const course = `${section.school}, ${section.course}`
  const variant_id = section.variant_id
  const sid = section.section_id
  const pid = section.pid

  return (
    <form className="registration-form" action="/cart/add" method="port">
      <input type="hidden" name="properties[Class]" value={course} />
      <input type="hidden" name="properties[_rid]" value={sid} />
      <input type="hidden" name="properties[_pid]" value={pid} />
      <input type="hidden" name="properties[_tempaccess]" value="0" />
      <input type="hidden" name="id" value={variant_id} />
      <input type="submit" className="button orange registration-link" value={props.buttonText}/>
    </form>
  )
}
